/**
 * @generated SignedSource<<1a068650687102c6acf15dd70947df44>>
 * @relayHash 11df15622137d899ae3fbfec59ad8686
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f1ec6c80450d3ba722ab175466c2c311ff006aefb1ddfb712d5f8a3db7c3bbb0

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraProjectStatus = "ACTIVE" | "ARCHIVED" | "DELETED" | "%future added value";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type servicesTrialSprintBoardProjectDataQuery$variables = {
  projectAri: string;
};
export type servicesTrialSprintBoardProjectDataQuery$data = {
  readonly jira: {
    readonly jiraProject: {
      readonly created: AGG$DateTime | null | undefined;
      readonly id: string;
      readonly key: string;
      readonly projectStyle: JiraProjectStyle | null | undefined;
      readonly projectType: JiraProjectType | null | undefined;
      readonly status: JiraProjectStatus | null | undefined;
      readonly tmpBoardId: AGG$Long | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type servicesTrialSprintBoardProjectDataQuery = {
  response: servicesTrialSprintBoardProjectDataQuery$data;
  variables: servicesTrialSprintBoardProjectDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
          }
        ],
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jiraProject",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "created"
          },
          {
            "kind": "ScalarField",
            "name": "tmpBoardId"
          },
          {
            "kind": "ScalarField",
            "name": "projectStyle"
          },
          {
            "kind": "ScalarField",
            "name": "projectType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "servicesTrialSprintBoardProjectDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "servicesTrialSprintBoardProjectDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "f1ec6c80450d3ba722ab175466c2c311ff006aefb1ddfb712d5f8a3db7c3bbb0",
    "metadata": {},
    "name": "servicesTrialSprintBoardProjectDataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4f66359ce8fd45935ef44b8742014c34";

export default node;
